import type { IconSvgObject } from './types';

const Plug01Icon: IconSvgObject = [
  ["path", { d: "M15.5 2V6M8.5 6V2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 11.3696V7C6 6.44772 6.44772 6 7 6H17C17.5523 6 18 6.44772 18 7V11.3696C18 11.7799 17.8738 12.1803 17.6385 12.5165L15.0972 16.1469C14.7229 16.6816 14.1113 17 13.4587 17H10.5413C9.88868 17 9.2771 16.6816 8.90285 16.1469L6.36154 12.5165C6.12622 12.1803 6 11.7799 6 11.3696Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M12 17V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11 9H13", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Plug01Icon;
